import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import AnimatedDonutChartDash from './AnimatedDonutChartDash';
import { formatToDecimals } from '@lib/helpers/formatting';
import NewLegend from './chartLegend';

const AnimatedDonutChartCard = ({ chartId, donutData, cardData, labelOnHover = true, totalName, title, code, valueInCircle }) => {
	const [totalValue, setTotalValue] = useState(0);

	useEffect(() => {
		setTotalValue(
			Number(
				donutData
					.filter((data) => data.propertyName === totalName)
					.map((data) => data.propertyValue)
					.join(),
			),
		);
	}, [donutData, totalName]);

	return (
		<>
			<Row
				className="flex-column align-items-center justify-content-between"
				style={{ minHeight: '30rem' }}
			>
				<h5 className="title-box mb-3">{title}</h5>

				<Col className="col-auto">
					<Row className="flex-column justify-content-center align-items-center w-100 m-auto">
						<Col className="dashChartBox donutCharts" style={{ minHeight: '13rem' }}>
							<AnimatedDonutChartDash
								chartId={chartId}
								data={donutData}
								labelOnHover={labelOnHover}
								totalName={totalName}
								code={code}
								valueInCircle={valueInCircle}
							/>
						</Col>
					</Row>
				</Col>

				<Col>
					<Row className="flex-column justify-content-center align-items-center w-100 m-auto mt-3">
						{cardData.length > 0 && (
							<NewLegend data={cardData} scope={title} totalName={totalName} className={chartId} totalValue={totalValue} showTotal={true} />
						)}
					</Row>
				</Col>
			</Row>

			<Row>
				<Col className="mt-auto">
					<Row className="totalDiv">
						<Col className="col-auto total-label f-600">Totale</Col>
						<Col className="total-value text-end f-600">{formatToDecimals(totalValue)}</Col>
					</Row>
				</Col>
			</Row>
		</>
	);
};

export default AnimatedDonutChartCard;
